import React, { useState } from 'react';
import { Button, Menu, MenuItem } from '@mui/material';
import { useTranslation } from 'react-i18next';
import IconButton from '../../shared/icon_button';

export const HamburgerDropdown = () => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <IconButton 
        icon='hamburger'
        width={36}
        height={36}
        onClick={handleClick}
        tooltip={t('nav.navMenuTooltip')}
      >
        Login
      </IconButton>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={handleClose} component="a" href='/'>{t('nav.home')}</MenuItem>
        <MenuItem onClick={handleClose} component="a" href='/events'>{t('nav.events')}</MenuItem>
      </Menu>
    </div>
  );
};